import React, { useEffect, useMemo } from "react";
import classNames from "classnames";

import { SelectProps } from "./types";

import { FrameDesignContent } from "../FrameDesignContent/FrameDesignContent";
import { QREditorContextProps } from "@/contexts/QREditorContext/types";
import { QREditorContext } from "@/contexts/QREditorContext";
import { getFrameSectionClass, handleFrameSelectedSection } from "@/utils/framesHelper";
import { BaseOption, Select } from "@npm_leadtech/qr-ui-components";
import { toFrameBaseOptions } from "../utils";
import "./styles.scss";

export const FramesSelect = ({
  id,
  dataQA,
  label,
  options,
  placeholder,
  error,
  success,
  disabled,
  name,
  className,
  prefix,
  onChange,
  defaultSelected,
  selectContent,
}: SelectProps) => {
  const classnames = classNames(`FramesSelect`, {
    [className]: className,
    "FramesSelect--error": error,
    "FramesSelect--success": success,
    "FramesSelect--disabled": disabled,
  });

  const { qrData } = React.useContext<QREditorContextProps<any>>(QREditorContext);

  const defaultValueIndex = useMemo(() => {
    const index = options.findIndex((option) => option.label === defaultSelected);
    return index >= 0 ? (index + 1).toString() : undefined;
  }, [options, defaultSelected]);

  const [value, setValue] = React.useState(defaultValueIndex);

  const baseOptions = React.useMemo<BaseOption[]>(
    () => toFrameBaseOptions(options.map((opt) => opt.label)),
    [options]
  );

  useEffect(() => {
    const isFrameSelected = handleFrameSelectedSection(
      selectContent,
      qrData,
      "frame-div-toggle-select"
    );

    if (isFrameSelected) {
      const label = isFrameSelected.content.selectParent;
      const index = options.findIndex((option) => option.label === label);

      if (index >= 0) {
        setValue((index + 1).toString());
      }
    }
  }, []);

  const handleSections = (optionSelected: string) => {
    getFrameSectionClass("frame-div-toggle-select", optionSelected);
  };

  const handleOnChange = (selectedValue: string) => {
    handleSections(selectedValue);
    setValue(selectedValue);

    if (onChange) {
      onChange(options[Number(selectedValue) - 1].label);
    }
  };

  return (
    <div id="frames-select">
      <div
        data-qa={dataQA}
        className={classnames}
      >
        {label && <label className="Select__label">{label}</label>}
        <div data-testid="frameSelect">
          <Select
            id={id}
            options={baseOptions}
            value={value}
            onChange={handleOnChange}
            prefix={prefix}
            placeholder={placeholder}
            disabled={disabled}
            multiple={false}
            dataQA={dataQA}
            name={name}
          />
        </div>
      </div>

      <div className="select-content">
        <FrameDesignContent
          content={selectContent}
          className="frame-div-toggle-select"
        />
      </div>
    </div>
  );
};
